import Drawer from "@material-ui/core/Drawer";
import React, { FC } from "react";

import SidebarList from "./SidebarList";
import classes from "./Sidebar.module.scss";

type SidebarProps = {
  isOpen: boolean;
  handleClose: () => void;
};

const Sidebar: FC<SidebarProps> = ({ isOpen, handleClose }) => {
  return (
    <div>
      <Drawer className={classes.drawer} anchor="right" open={isOpen} onClose={handleClose}>
        <SidebarList handleClose={handleClose} />
      </Drawer>
    </div>
  );
};

export default Sidebar;
